import { combineReducers } from 'redux';

import preferenceReducer from './preferences';

const reducers = combineReducers({
  preferences : preferenceReducer
});

const rootReducer = (state, action) => {
  return reducers(state, action);
};

export default rootReducer;
